module.exports = __webpack_public_path__ + "img/circle2.ee5e2634.svg";